import { useState, useEffect } from 'react';

export const useThemeDetector = () => {
    const getCurrentTheme = () => window.matchMedia('(prefers-color-scheme: dark)').matches;

    const [isDarkTheme, setIsDarkTheme] = useState(getCurrentTheme());

    useEffect(() => {
        const darkMatcher = window.matchMedia('(prefers-color-scheme: dark)');

        const listener = (e: any) => setIsDarkTheme(e.matches);

        darkMatcher.addEventListener('change', listener);
        return () => darkMatcher.removeEventListener('change', listener);
    }, []);

    return isDarkTheme;
};
